import { useQuery } from 'react-query';
import { queryConfirmedCompanies } from './useConfirmedCompanies.query';
import { ConfirmedCompaniesQueryParams } from './useConfirmedCompanies.types';
import { AllCompaniesQueryResponse } from '../../../types/api/endpoints/companies/allCompany.types';

export const ALL_COMPANIES_QUERY_KEY = 'ALL_COMPANIES';

export const useConfirmedCompanies = (params: ConfirmedCompaniesQueryParams) => {
  return useQuery<AllCompaniesQueryResponse, Error>(
    [ALL_COMPANIES_QUERY_KEY, params],
    // ALL_COMPANIES_QUERY_KEY,
    () => queryConfirmedCompanies(params),
    {
      retry: false,
      refetchOnWindowFocus: false,
    }
  );
};
